import { Button, FormGroup } from "reactstrap";
import { Component } from "../../..";
import { Tax } from "../../../shared/api";
import { App } from "../../App";
import { EditTax } from "./EditTax";

export type TaxListProps = {
	country: Tax.CountryType;
	taxes: Tax.TaxType[];
	on_save_tax: (tax: Tax.TaxType) => any;
	on_delete_tax?: (tax: Tax.TaxType) => any;
	on_edit_country?: () => void;
};

export function TaxList(props: TaxListProps) {

	let taxes_e: JSX.Element[] = [];

	const edit_tax = (tax?: Tax.TaxType) => {
		App.open(() => (
			<EditTax tax={tax} country={props.country} on_save={props.on_save_tax} on_delete={props.on_delete_tax} />
		), false);
	}
	
	for(let tax of props.taxes) {
		taxes_e.push(
			<Component.Card onClick={() => edit_tax(tax)}>
				{tax.is_default ? <p style={{float: "right"}}>Default</p> : <></>}
				<p>{tax.label} {(tax.rate * 100).toLocaleString()}%</p>
			</Component.Card>
		)
	}

	let status_msg: string | null;
	
	switch(props.country.state) {
	case "UNTAXED":
		status_msg = "Untaxed";
		break;
	case "BLOCKED":
		status_msg = "Blocked";
		break;
	case "TAXED":
		status_msg = null;
		break;
	}

	return (
		<FormGroup key={props.country.code}>
			<h5>{props.country.label} {props.country.tax_type ? `(${props.country.tax_type})` : ``} {status_msg ? `(${status_msg})` : ``}</h5>
			{taxes_e}
			<Button onClick={() => edit_tax()}>Add</Button>
			{props.on_edit_country ? <Button onClick={props.on_edit_country}>Edit</Button> : <></>}
		</FormGroup>
	);
}

